import { render, staticRenderFns } from "./ProdKanbanTV.vue?vue&type=template&id=493280ce&"
import script from "./ProdKanbanTV.vue?vue&type=script&lang=js&"
export * from "./ProdKanbanTV.vue?vue&type=script&lang=js&"
import style0 from "./ProdKanbanTV.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports